import moment from 'moment';

export function isAdult(date) {
  return moment().diff(date, 'years') >= 18;
}

export function timestamp(date) {
  return moment(date).valueOf() || moment.now();
}
